import { useEffect, useState } from 'react';

export const useTextArea = ({
  onChange,
  defaultValue,
  fieldName,
}: {
  onChange: (field: string, value: any) => void;
  defaultValue: string;
  fieldName: string;
}) => {
  const [currentText, setCurrentText] = useState(defaultValue || '');

  useEffect(() => {
    onChange(fieldName, currentText);
  }, [currentText]);
  return { setCurrentText, currentText };
};
